import { Flex } from '@chakra-ui/react'
import { useState, useCallback } from 'react'
import { TravelHistoryTable } from '../TravelHistoryPage/components/TravelHistoryTable'
import { InfoSection } from './components/InfoSection'
import { PaymentDueBar } from './components/PaymentDueBar'
import { useTranslation } from 'react-i18next'

function Home() {
  const [showHistory, setShowHistory] = useState(false)

  const handleInfoDone = useCallback(() => {
    setShowHistory(true)
  }, [])

  return (
    <Flex direction='column' gap='20px' flex='1'>
      <PaymentDueBar />
      <InfoSection onEnterComplete={handleInfoDone} />
      {showHistory && <TravelHistoryTable home />}
    </Flex>
  )
}

export default Home
